
import { useEffect, useState } from 'react'
import Style from './style2.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import UpdateRepairPopup from './update'

const UpdateRepair = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, repairId, dropdown = []}) => {

    const [allRecords, setAllRecords] = useState([])

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>

                    <UpdateRepairPopup
                        onClose={onClose}
                        onError={onError}
                        onSubmit={onSubmit}
                        Style={Style}
                        dropdown={dropdown}
                        repairId={repairId}
                    />
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default UpdateRepair
